import { render } from "./ValuesContent.vue?vue&type=template&id=6fa2ad36&scoped=true&ts=true"
import script from "./ValuesContent.vue?vue&type=script&lang=ts"
export * from "./ValuesContent.vue?vue&type=script&lang=ts"

import "./ValuesContent.vue?vue&type=style&index=0&id=6fa2ad36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa2ad36"]])

export default __exports__